import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentUser: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    updUser: (state, action) => {
      state.currentUser = action.payload;
    },
  },
});

export const { updUser } = userSlice.actions;

export default userSlice.reducer;
